import type { Notice } from "@frontier/protocol/contracts";

export function noticeMessage(notice: Notice): string {
  switch (notice.code) {
    case "HOLD_FULL":
      return "Для этого груза нет места. Открой трюм, чтобы управлять грузом.";
    case "TOO_FAR":
      return "Цель недоступна или слишком далеко. Подлети ближе или выбери другую.";
    default:
      return notice.message;
  }
}
